import React, { useState } from "react";
import { Container } from "./styles";
import Fechar from "../../Images/fechar2.png";

export default function Simulador({setAbreModalSimulador}) {
  const [kilos, setKilos] = useState(0);
  const [departamento, setDepartamento] = useState(0);
  const [cpf, setCpf] = useState("13217239890");

  return (
    <Container>
      <div id="calculo">
        <img
          src={Fechar}
          className="fecha"
          onClick={() => setAbreModalSimulador(false)}
        />

        <div id="form">
          <small>Informe a qtd de Kg:</small>
          <input
            type="text"
            value={kilos}
            placeholder="Informe a qtd de Kg"
            onChange={(e) => setKilos(parseInt(e.target.value > 0 ? e.target.value : 0))
            }
          />

          <div id="total">
            <small>Total de pontos:</small>
            <strong>{kilos < 25 ? 0 : kilos / 25}</strong>
          </div>

          <strong style={{ position: "relative", top: 15 }}>
            Os pontos simulados serão acumulados somente após o faturamento da
            NFE.
          </strong>
        </div>
      </div>
    </Container>
  );
}
